import React from "react";
import { Text, Card, View } from "@components/atoms/Themed";
import Spacer from "@components/atoms/Spacer";
import Fonts from "@constants/Fonts";
import Colors from "@constants/Colors";
import DialogButton from "@components/molecules/dialog/DialogButton";
import {
  StyleSheet,
  Modal,
  TouchableWithoutFeedback,
  View as RnView,
} from "react-native";

type Props = {
  /** タイトル */
  title?: string;
  /** 表示するメッセージ */
  message: string;
  /** エラーの詳細情報 */
  details?: Record<string, unknown>;
  /** 閉じるボタンを押したときのハンドラ */
  onClose: () => void;
};

export default function ErrorDialog({
  title = "エラーが発生しました",
  message,
  // eslint-disable-next-line unused-imports/no-unused-vars, @typescript-eslint/no-unused-vars
  details,
  onClose,
}: Props): JSX.Element {
  return (
    <Modal animationType="none" onRequestClose={onClose} transparent visible>
      <View style={styles.container}>
        <View style={styles.wrapper}>
          <Card style={styles.message}>
            <Text style={styles.title}>{title}</Text>
            <Spacer height={16} />
            <Text style={styles.text}>{message}</Text>

            {/* {details != null && Object.keys(details).length > 0 && (
              <>
                <Spacer height={12} />
                <ScrollView style={styles.detailsContainer}>
                  <View style={styles.detailsContent}>
                    {Object.entries(details).map(([key, value]) => (
                      <View key={key} style={styles.detailRow}>
                        <RNText style={styles.detailKey}>{key}:</RNText>
                        <RNText style={styles.detailValue}>
                          {typeof value === "object"
                            ? JSON.stringify(value, null, 2)
                            : String(value)}
                        </RNText>
                      </View>
                    ))}
                  </View>
                </ScrollView>
              </>
            )} */}

            <Spacer height={24} />
            <View style={styles.buttons}>
              <DialogButton onPress={onClose} title="閉じる" type="white" />
            </View>
          </Card>
        </View>
        <TouchableWithoutFeedback onPress={onClose}>
          <RnView style={styles.backgroundLayer} />
        </TouchableWithoutFeedback>
      </View>
    </Modal>
  );
}
const styles = StyleSheet.create({
  container: {
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    flex: 1,
    zIndex: 10,
  },
  backgroundLayer: {
    position: "absolute",
    width: "100%",
    height: "100%",
    top: 0,
    left: 0,
    zIndex: -1,
    backgroundColor: Colors.overlayDark,
  },
  wrapper: {
    padding: 24,
  },
  message: {
    padding: 16,
    borderRadius: 6,
    maxWidth: 345,
    minWidth: "90%",
  },
  title: {
    color: Colors.orange,
    ...Fonts.xxlb140,
    textAlign: "center",
  },
  text: {
    ...Fonts.xlr160,
  },
  buttons: {
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
  },
  detailsContainer: {
    maxHeight: 200,
  },
  detailsContent: {
    backgroundColor: "#FFF8F0",
    padding: 8,
    borderRadius: 4,
    borderLeftWidth: 3,
    borderLeftColor: Colors.orange,
  },
  detailRow: {
    marginBottom: 4,
  },
  detailKey: {
    ...Fonts.xsr100,
    color: "#666666",
    fontWeight: "600",
  },
  detailValue: {
    ...Fonts.xsr100,
    color: "#333333",
    marginLeft: 8,
  },
});
